import ButtonIcon from "ds/components/ButtonIcon";
import LinkButtonIcon from "ds/components/ButtonIcon/LinkButtonIcon";
import DropdownMenuEllipsis, {
  DropdownMenuEllipsisProps,
} from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";

import { type TableCellAction } from ".";
import styles from "./styles.module.css";

type TableCellContentActionsProps = {
  actions: TableCellAction[];
} & Pick<DropdownMenuEllipsisProps, "onOpenChange">;

const TableCellContentActions = ({ actions, onOpenChange }: TableCellContentActionsProps) => {
  if (actions.length === 1) {
    const action = actions[0];

    if ("href" in action && action.href) {
      return (
        <LinkButtonIcon
          variant="ghost"
          href={action.href}
          icon={action.icon}
          className={styles.action}
          onClick={action.onPress}
        >
          {action.title}
        </LinkButtonIcon>
      );
    }

    return (
      <ButtonIcon
        variant="ghost"
        onPress={action.onPress}
        icon={action.icon}
        className={styles.action}
      >
        {action.title}
      </ButtonIcon>
    );
  }

  return (
    <DropdownMenuEllipsis
      tooltip="Cell options"
      onOpenChange={onOpenChange}
      className={styles.action}
    >
      {actions.map((action, i) =>
        "href" in action && action.href ? (
          <DropdownMenuItem key={i} href={action.href} onAction={action.onPress}>
            {action.title}
          </DropdownMenuItem>
        ) : (
          <DropdownMenuItem key={i} onAction={action.onPress}>
            {action.title}
          </DropdownMenuItem>
        )
      )}
    </DropdownMenuEllipsis>
  );
};

TableCellContentActions.displayName = "DS.TableCellContent.Actions";

export default TableCellContentActions;
